const markerIsSelected = ({ thisPoint, selectedPoint }) => {
  // 既存のポイントの場合（フェッチした時に存在する）
  if (!thisPoint.newItem.new) {
    return thisPoint.id === selectedPoint.id
  }

  // 新規ポイントの場合（フェッチした時に存在しない）
  return thisPoint.newItem.id === selectedPoint.newItem.id
}

export default markerIsSelected
